module.exports = __webpack_public_path__ + "img/thumb_15.226fc24e.jpg";